export const GET_ALLJOBS = "GET_ALLJOBS"
export const GET_ALLJOBS_FIVEDAYS = "GET_ALLJOBS_FIVEDAYS"